import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalConfirmation } from '@/lib/v2/organisms';

import { useActionsRules } from '@/src/modules/AutomationModuleNew/hooks/Rules/useActionsRules';

type DeleteRulesModalProps = {
  totalRowSelected: number;
  isOpen: boolean;
  onClose: () => void;
  ids: number[];
  refetchData: () => void;
};

const DeleteRulesModal = ({
  totalRowSelected,
  isOpen,
  onClose,
  ids,
  refetchData,
}: DeleteRulesModalProps) => {
  const { t } = useTranslation();

  const { deleteAction, isLoading } = useActionsRules();

  const handleConfirmDeletion = useCallback(async () => {
    await deleteAction(ids);
    onClose();
    refetchData();
  }, [deleteAction, ids, onClose, refetchData]);

  return (
    <ModalConfirmation
      isLoading={isLoading}
      isOpen={isOpen}
      textCancelButton={t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.cancelButton')}
      textConfirmButton={t('CAMPAIGNS_MAIN.DELETE_CAMPAIGNS.successButton')}
      title={
        totalRowSelected >= 2
          ? t('DeleteRulesModal.multiple.title')
          : t('DeleteRulesModal.single.title')
      }
      onClose={onClose}
      onConfirmButton={handleConfirmDeletion}
    />
  );
};

export default memo(DeleteRulesModal);
